<template>
  
    <b-modal
        :title="$t('history.modal.header.AddPriceLines')"
        ref="costPriceLines-modal"
        @ok="savePriceLines"
        @cancel="reset"
        @hide="reset"
        @show="getPriceLinesAndAccount"
        :no-close-on-backdrop="true"
    >
      <b-overlay :show="show" rounded="sm">
        <form ref="form">
          <b-form-select v-model="setPriceType" :options="options" size="sm" class="mt-3" />
            <div v-for="(item, index) in priceLines" v-bind:key="index">
                <b-form-group
                    :label="$t('history.modal.body.PriceLines')"
                >
                    <b-row>
                        <b-col>
                            <b-form-input
                                size="sm"
                                required
                                type="number"
                                step="0.01"
                                v-model="item.ValueCost"
                                min="0"
                                :placeholder="$t('history.placeholder.DKK')"
                            ></b-form-input>
                        </b-col>
                        <b-col>
                            <vSelect
                                :dynamicWidth="false"
                                :clearable="false"
                                :options="priceLineTypes"
                                :reduce="(priceLine) => priceLine.id"
                                label="name"
                                v-model="item.PriceLinesTypeID"
                                :placeholder="$t('createShipment.placeholder.Select Fee Type')"
                            />
                        </b-col>

                        <b-input-group-append
                            class="addPriceLineIcon"
                            v-if="index === 0"
                        >
                            <font-awesome-icon
                                @click="addPriceLine"
                                icon="plus-circle"
                                size="lg"
                            />
                        </b-input-group-append>

                        <b-input-group-append
                            v-if="index > 0"
                            class="addPriceLineIcon"
                        >
                            <font-awesome-icon
                                @click="removePriceLine(index)"
                                icon="minus-circle"
                                size="lg"
                            />
                        </b-input-group-append>
                    </b-row>
                </b-form-group>
            </div>
        </form>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">Cancel</b-button>
            <b-button
                @click="ok()"
                name="addPriceLinesModalButton"
                :disabled="disableButton"
                variant="primary"
            >{{ $t('history.modal.button.AddPriceLines') }}</b-button>
        </template>
      </b-overlay>
    </b-modal>
</template>
<script>
  import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '@/store/constants';
  import helpers from '@/helper';
  import vSelect from '../../vSelect';
  import { mapGetters } from 'vuex';

  export default {
      props: {
          shipmentId: { type: Number, required: true },
          linkId: {type: String}
      },

      components: {
          vSelect,
      },

      computed: {
          disableButton() {
              return this.priceLines.some((x) => x.PriceLinesTypeID == '');
          }
      },
      data() {
          return {
              accounts: [],
              priceLineTypes: [],
              priceLines: [{ ValueSale: '', PriceLinesTypeID: '' }],
              selectedCompany: '',
              selectedAccount: '',
              setPriceType: '',
              show: false,
              options: [
                { value: '', text: 'Choose Type'},  
                { value: 'FixedCost', text:'Fixed Cost'}
              ],
          };
      },

    methods: {
          async getPriceLineTypes() {
              const response = await this.$store.dispatch(
                  HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_PRICE_LINE_TYPES
              );

              this.priceLineTypes = response.data;
          },
      
          async getPriceLinesAndAccount(){
            this.show = true
            let payload = {
              shipmentId: this.shipmentId,
              linkId: this.linkId
            }
            const response = await this.$store.dispatch(
                HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_PRICE_LINES, payload
            );
            
            if(response !== undefined){
              await this.setPriceLinesAndAccounts(response)
            }
          },
      
          async setPriceLinesAndAccounts(response){
            this.priceLines = []
            response.priceLines.forEach(pl => this.priceLines.push({PriceLinesTypeID: pl.priceLinesTypeID, ValueSale: pl.valueSale, ValueCost: pl.valueCost}))

            await this.getPriceLineTypes();
            if(this.priceLines.length === 0) this.priceLines = [{ ValueSale: '', PriceLinesTypeID: '' }];
            this.show = false;
          },

          showAddPriceLinesModal() {
              this.$refs['costPriceLines-modal'].show();
          },

          addPriceLine() {
              this.priceLines.push({ ValueSale: '', PriceLinesTypeID: '' });
          },

          removePriceLine(index) {
              this.priceLines.splice(index, 1);
          },

          savePriceLines() {
              const request = {
                  PriceLines: this.priceLines,
                  ShipmentId: this.shipmentId,
                  SetPriceType : this.setPriceType,
              };

              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.ADD_PRICE_LINES, request);
          },

          reset() {
              this.selectedCompany = '';
              this.selectedAccount = '';
              this.accounts = [];
              this.priceLines = [{ ValueSale: '', PriceLinesTypeID: '' }];
          }
      },
  };
</script>

<style>
  .addPriceLineIcon {
      margin-right: 15px;
  }
</style>
